<template>
  <div class="contract-info-bd">
    <!-- <div class="title">{{ $t('page_contract_he_tong_xin_xi') }}</div> -->
    <div class="info-wrap">
      <div class="item-onfo">
        <h1 class="sub-title">{{ $t('crm_contract_info_trail.ji_chu_xin_xi') }}</h1>
        <ul class="ubw">
          <li>
            <span
              class="label"
              v-if="bizClassType === 'contract'"
            >{{ $t('crm_contract_info_trail.he_tong_zhuang_tai') }}：</span>
            <span
              class="label"
              v-if="bizClassType === 'order'"
            >{{ $t('crm_contract_info_trail.ding_dan_zhuang_tai') }}：</span>
            <span>{{ getDicValue('crm_contract_biz_state', detail.bizState) }}</span>
          </li>
          <li>
            <span
              class="label"
              v-if="bizClassType === 'contract'"
            >{{ $t('crm_contract_info_trail.he_tong_lei_xing') }}：</span>
            <span
              class="label"
              v-if="bizClassType === 'order'"
            >{{ $t('crm_contract_info_trail.ding_dan_lei_xing') }}：</span>
            <span>{{ getDicValue('crm_contract_type', detail.bizClass) }}</span>
          </li>
          <!-- <li>
            <span class="label">{{ $t('page_contract_qian_ding_ri_qi') }}：</span>
            <span>{{ detail.signingDate || '/' }}</span>
          </li> -->
          <li>
            <span
              class="label"
              v-if="bizClassType === 'contract'"
            >{{ $t('crm_contract_info_trail.he_tong_bian_hao') }}：</span>
            <span
              class="label"
              v-if="bizClassType === 'order'"
            >{{ $t('crm_contract_info_trail.ding_dan_bian_hao') }}：</span>
            <span>{{ detail.contractNo }}</span>
          </li>
          <!-- <li>
            <span class="label">{{ $t('page_contract_sghth') }}：</span>
            <span>{{ detail.customContractNo }}</span>
          </li> -->
          <li>
            <span class="label">{{ $t('crm_contract_info_trail.jiao_huo_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.deliveryDate, 'YYYY-MM-DD') }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_trail.ying_yong_chang_jing') }}：</span>
            <span>{{ getDicValue('crm_contract_usage_scene', detail.usageScene) }}</span>
          </li>
          <!-- 所属项目/区域 -->
          <li>
            <span class="label">{{ $t('crm_contract_info_trail.ssxmqy') }}：</span>
            <span>{{ getLocationNameAndSiteName(detail) }}</span>
          </li>
          <!-- <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('page_contract_he_tong_ya_jin') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('page_contract_ding_dan_ya_jin') }}：</span>
            <span>{{ detail.rentalDeposit }}</span>
          </li> -->
          <li style="width: 100%">
            <span class="label">{{ $t('crm_contract_info_trail.shi_yong_di_zhi') }}：</span>
            <span>{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city != detail.province ? detail.city || '' : '' }}{{ detail.useAddress || '' }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_trail.sheng_xiao_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.effectiveDate, 'YYYY-MM-DD') || '/' }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_trail.zhuan_zu_lin') }}：</span>
            <span>{{getDicValue('isynergy_cloud_bool', detail.toRental)}}</span>
          </li>
          <li>
            <span class="label">{{$t('crm_contract_info_trail.jiao_fei')}}：</span>
            <span>{{getDicValue('isynergy_cloud_bool', detail.isCharge)}}</span>
          </li>
          <li>
            <span class="label">{{$t('crm_contract_info_trail.shi_yong_yuan_yin')}}：</span>
            <span>{{detail.rentalReason || '-'}}</span>
          </li>
        </ul>
      </div>
      <div class="item-company">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info_trail.jia_fang_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.jfsqdb') }}</span>
                <span>{{ detail.partyAName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.ye_wu_fu_ze_ren') }}</span>
                <span>{{ detail.salesman }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.lian_xi_dian_hua') }}</span>
                <span>{{ detail.salesmanPhone }}</span>
              </li>
              <li>
                <span class="label">{{$t('crm_contract_info_trail.yin_hang_zhang_hao')}}</span>
                <span>{{ getBankAccount(detail) || '-' }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.sqdbdz') }}</span>
                <span>{{ detail.partyAAddress }}</span>
              </li>
            </ul>
          </div>
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info_trail.yi_fang_xin_xi') }}</h1>
            <ul style="margin-bottom: 24px">
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.yfgsmc') }}</span>
                <span>{{ detail.customerName }}</span>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.xiang_mu_fu_ze_ren') }}</span>
                    <span>{{ detail.projectContactName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.projectContactPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.shou_quan_dai_biao') }}</span>
                    <span>{{ detail.signerName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.signerPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.fa_ren_xing_ming') }}</span>
                    <span>{{ detail.legalPerson }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_trail.frsfzhm') }}</span>
                    <span>{{ detail.identityCard }}</span>
                  </div>
                </div>
              </li>
              <li>
                <span class="label">{{$t('crm_contract_info_trail.wu_liu_gong_si')}}</span>
                <span>{{ detail.logisticsCompanyName || '-' }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.yi_fang_di_zhi') }}</span>
                <span>{{ detail.customerAddress }}</span>
              </li>
            </ul>
            <h1 class="sub-title">{{ $t('crm_contract_info_trail.yfshxx') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_huo_ren') }}</span>
                <span v-if="detail.cdeliverAddress">{{ detail.cdeliverAddress.consigneeName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.lian_xi_dian_hua') }}</span>
                <span v-if="detail.cdeliverAddress">{{ detail.cdeliverAddress.consigneePhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_huo_di_zhi') }}</span>
                <span v-if="detail.cdeliverAddress">
                  {{ detail.cdeliverAddress.country || '' }}{{ detail.cdeliverAddress.province || ''
                  }}{{ detail.cdeliverAddress.city != detail.cdeliverAddress.province ? detail.cdeliverAddress.city || '' : '' }}{{ detail.cdeliverAddress.detailAddress || '' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="item-aftersale">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info_trail.shou_hou_zhong_xin') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_hou_gong_si') }}</span>
                <span>{{ detail.afterServiceName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_hou_fu_ze_ren') }}</span>
                <span>{{ detail.technicianName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shfzrdh') }}</span>
                <span>{{ detail.technicianPhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_hou_fu_jia_fei') }}/{{ $t('crm_contract_info_trail.yue') }}</span>
                <span>{{ detail.afterServiceSurcharge }}</span>
              </li>
            </ul>
          </div>
          <div class="ub-f2">
            <h1 class="sub-title">{{ $t('crm_contract_info_trail.shshxx') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_huo_ren') }}</span>
                <span v-if="detail.sdeliverAddress">{{ detail.sdeliverAddress.consigneeName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.lian_xi_dian_hua') }}</span>
                <span v-if="detail.sdeliverAddress">{{ detail.sdeliverAddress.consigneePhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_trail.shou_huo_di_zhi') }}</span>
                <span v-if="detail.sdeliverAddress">
                  {{ detail.sdeliverAddress.country || '' }}{{ detail.sdeliverAddress.province || ''
                  }}{{ detail.sdeliverAddress.city != detail.sdeliverAddress.province ? detail.sdeliverAddress.city || '' : '' }}{{ detail.sdeliverAddress.detailAddress || '' }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--
        甲方代表为总部时，无需显示甲方授权代表，
        甲方代表与售后一致时无需显示售后，
        总部与售后一致时无需显示售后。
       -->
      <div class="info-lease">
        <h1 class="sub-title">{{ $t('crm_contract_info_trail.she_bei_xin_xi') }}</h1>
        <div class="sum-content">
          <!-- 甲方代表应收 -->
          <div
            class="sum-item"
            v-if="detail.partyAId != detail.hqId"
          >
            <div class="sum-item-key">{{$t('crm_contract_info_trail.jfdbys')}}：</div>
            <div class="sum-item-val">￥{{schemeInfo.agentCoProfitTotal || 0}}</div>
          </div>
          <!-- 售后应收 -->
          <div
            class="sum-item"
            v-if="(detail.partyAId != detail.afterServiceId) && (detail.hqId != detail.afterServiceId)"
          >
            <div class="sum-item-key">{{$t('crm_contract_info_trail.shou_hou_ying_shou')}}：</div>
            <div class="sum-item-val">￥{{schemeInfo.serviceProfitTotal || 0}}</div>
          </div>
          <!-- 总部应收 -->
          <div
            class="sum-item"
            v-if="detail.isCharge == '1'"
          >
            <div class="sum-item-key">{{$t('crm_contract_info_trail.zong_bu_ying_shou')}}：</div>
            <div class="sum-item-val">￥{{schemeInfo.hqProfitTotal || 0}}</div>
          </div>
          <!-- 客户应付 -->
          <div
            class="sum-item"
            v-if="detail.isCharge == '1'"
          >
            <div class="sum-item-key">{{$t('crm_contract_info_trail.ke_hu_ying_fu')}}：</div>
            <div class="sum-item-val">￥{{schemeInfo.firstTotal || 0}}</div>
          </div>
        </div>
        <custom-table
          :index="true"
          :data="schemeList"
          tableCode="contract_info_trail"
          :filterArr="filterArr"
        ></custom-table>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  components: {},
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    detail: {
      immediate: true,
      handler(val) {
        if (val && Object.keys(val).length) {
          this.initFilterArr();
        }
      }
    }
  },
  data() {
    return {
      contractId: '',
      contractClass: '',
      schemeList: [],
      schemeInfo: {},
      paymentList: [],
      paymentInfo: {},
      certificateData: {},
      contractFile: [],
      classMap: {
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        trail_order: 10, // 试用订单
      },
      approveMap: {
        20: 'leasing_contract', // 租赁合同
        21: 'lease_renewal_contract', // 续租合同
        30: 'frame_contract', // 框架协议
        31: 'frame_order', // 协议订单
        10: 'trail_order', // 试用订单
      },
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
      filterArr: [],
    };
  },
  mounted: function () {
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass');
    if (this.contractBizClass.includes(this.contractClass)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(this.contractClass)) {
      this.bizClassType = 'order';
    }
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.contractClass) {
      this.contractClass = this.classMap[this.approveType];
    }
    if (!this.approveType && this.contractClass) {
      this.approveType = this.approveMap[this.contractClass];
    }
    this.getListScheme();
  },
  methods: {
    // 租赁计算
    computedNum: function (row, name) {
      // 累计押金
      if (name === 'depositFeeTotal') {
        row.depositFeeTotal = (+row.depositFee * +row.bookingNum).toFixed(2);
        return row.depositFeeTotal;
      }
      // 首期租金(合计)
      if (name === 'firstRentTotal') {
        row.firstRentTotal = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum).toFixed(2);
        return row.firstRentTotal;
      }
      // 首期需支付
      if (name === 'firstPay') {
        row.firstPay = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum + +row.depositFee * +row.bookingNum).toFixed(2);
        return row.firstPay;
      }
      // 租赁期数
      if (name === 'periodNum') {
        row.periodNum = Math.ceil(+row.rentalTerm / (+row.paymentPeriod || +row.rentalTerm || 0));
        return row.periodNum;
      }
      // 首期租金/台
      if (name === 'firstRent') {
        row.firstRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm)).toFixed(2);
        return row.firstRent;
      }
      // 累计租金/台
      if (name === 'totalRent') {
        row.totalRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * +row.rentalTerm).toFixed(2);
        return row.totalRent;
      }
      return '';
    },
    /**
     * 甲方代表为总部时，无需显示甲方授权代表，
        甲方代表与售后一致时无需显示售后，
        总部与售后一致时无需显示售后。

        如果不缴费时，不需要显示：客户应付，总部应收。
     */
    initFilterArr() {
      // agentCoProfit - 甲方授权代表
      // afterServiceProfit - 售后
      const arr = [];
      const detail = this.detail;
      const {
        // 甲方
        partyAId,
        // 售后
        afterServiceId,
        // 总部（工厂）
        hqId, isCharge, } = detail;
      if (partyAId === hqId) {
        arr.push('agentCoProfit');
      }
      if (
        (partyAId === afterServiceId) || (hqId === afterServiceId)
      ) {
        arr.push('afterServiceProfit');
      }
      if (`${isCharge}` === '0') {
        arr.push('unitPrice');
        arr.push('hqProfit');
      }

      this.filterArr = arr;
    },
    // 首付款列表1
    getListScheme: function () {
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        const data = res.data;
        const schemeList = data.goodsList || [];
        schemeList.forEach((i) => {
          i.hqShipTo = `${i.hqShipTo}`;
        });
        this.schemeList = schemeList;
        this.schemeInfo = data;
      });
    },
    // 获取银行账号
    getBankAccount(info) {
      const {
        partyADepositNumber,
        partyADepositName,
        partyADepositBank,
      } = info;
      const ret = [];

      if (partyADepositNumber) {
        ret.push(partyADepositNumber);
      }
      if (partyADepositName) {
        ret.push(partyADepositName);
      }
      if (partyADepositBank) {
        ret.push(partyADepositBank);
      }

      return ret.join('/');
    }
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.contract-info-bd {
  background-color: #ffffff;
  .contract-scheme {
    > div {
      width: 180px;
      margin-bottom: 10px;
      > p:first-child {
        font-weight: 500;
        font-size: 12px;
      }
      p {
        line-height: 20px;
      }
    }
  }
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  .title {
    line-height: 50px;
    height: 50px;
    padding-left: 20px;
    color: $title-color;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #eef2f8;
  }
  .info-wrap {
    padding: 20px 24px;
    .sub-title {
      color: $title-color;
      font-size: 12px;
      line-height: 32px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .item-onfo {
      border-bottom: 1px solid #eef2f8;
      padding: 0 16px 12px;
      ul > li {
        width: 33.3%;
      }
    }
    .item-company {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f1:first-child {
        padding-right: 20px;
        border-right: 1px solid #eef2f8;
        margin-right: 16px;
      }
    }
    .item-aftersale,
    .item-firstpay {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f2 {
        padding-left: 48px;
      }
    }
    .info-lease {
      padding: 12px 16px;
    }
    .info-item {
      padding: 12px 16px;
      .el-upload-list {
        display: flex;
      }
      .el-upload-list__item {
        background: rgba(248, 249, 251, 1);
        line-height: 32px;
        height: 32px;
        color: #0d9ae0;
        width: 306px;
        border-radius: 2px;
        padding: 0 10px;
        margin-right: 14px;
        margin-top: 0;
        &:first-child {
          margin-top: 0;
        }
        i.el-icon-document {
          display: none;
        }
        a.el-upload-list__item-name {
          color: #0d9ae0;
        }
        i.el-icon-circle-check::before {
          color: #0d9ae0;
          font-family: 'icon';
          font-size: 12px;
          font-style: normal;
          margin-right: 4px;
          -webkit-font-smoothing: antialiased;
          content: '\e6ec';
        }
      }
    }
    ul > li {
      line-height: 23px;
      // height: 23px;
      color: #6c757d;
      font-size: 12px;
      .label {
        color: #495057;
        width: 120px;
        display: inline-block;
        vertical-align: top;
      }
      a {
        text-decoration: underline;
      }
    }
  }

  .sum-content {
    overflow: hidden;
    padding-bottom: 15px;

    .sum-item {
      float: right;
      margin-left: 20px;
      font-size: 12px;

      &-key {
        float: left;
      }
      &-val {
        float: left;
        color: #0d9ae0;
      }
    }
  }
}
</style>
